// @ts-nocheck
import React from "react"
import styled from "styled-components"

import { Styles } from "../../../../../config"
import { _getLabelConfig, _getTextColor } from "../_util"
import Box from "@mui/material/Box"
import { Popovers } from "../../../../../element-components"

const FilterLabel = styled.label`
	touch-action: manipulation;
	left: 0;
	top: 0;
	font-size: 1rem;
`

const DefaultLabel = styled.label`
	color: ${(props) => {
		if (props.hideLabel) return "white"
		return Styles.Color[
			_getTextColor({
				error: props.error,
				isFocused: props.isFocused,
				isHover: props.isHover,
				disabled: props.disabled
			})
		]
	}};

	transition: all 100ms ease-in-out;
	transform-origin: left;
	touch-action: manipulation;
	left: 0;
	top: 0;

	font-size: ${(props) => {
		if (Boolean(props.labelSize)) return props.labelSize
		else return "1rem"
	}};

	opacity: ${(props) => (props.disabled ? 0.7 : 1)};
	background: ${(props) => (props.input === "textarea" || props.input === "slate") && Styles.Color.white};
	${(props) =>
		_getLabelConfig({
			input: props.input,
			isFilled: props.isFilled,
			isFocused: props.isFocused
		})}
`

const Label= (props) => {
	const { isFilled, popoverText } = props

	if (props.formStyle === "filter") return <FilterLabel {...props}></FilterLabel>
	else if (Boolean(popoverText) && popoverText !== "") {
		const updatedProps = structuredClone(props)
		updatedProps.labelSize = "1rem"
		if (isFilled) updatedProps.labelSize = ".75rem"

		const popoverColor = _getTextColor({
			error: props.error,
			isFocused: props.isFocused,
			isHover: props.isHover,
			disabled: props.disabled
		})

		return (
			<Box style={{ justifyContent: "center", alignItems: "center" }}>
				<DefaultLabel {...updatedProps}></DefaultLabel>
				<Popovers.Icon
					popoverConfig={{ text: popoverText }}
					iconConfig={{ name: "info", size: "very-small" }}
					margin="0 0 0 5px"
					color={popoverColor}
				></Popovers.Icon>
			</Box>
		)
	} else return <DefaultLabel {...props}></DefaultLabel>
}

export default Label
